<template>
  <div class="download">
    <div class="download__content-wrapper">
      <div v-if="showIcon"
           class="download__icon">
        <font-awesome-icon :icon="icon"></font-awesome-icon>
      </div>

      <div class="download__content">
        <div class="download__header">
          <h3 class="download__heading">
            {{ title || name }}
          </h3>
          <div v-if="selectable"
               class="download__select">
            <b-form-group>
              <b-form-checkbox
                v-model="isChecked"
                :aria-label="
                  isChecked
                    ? `${name} is marked for download`
                    : `${name} is currently not marked for download`
                "
                @change="handleUserSelectedDownload">
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>

        <slot name="description" />

        <div v-if="showFileExtension || showFileSize"
             class="download__info">
          <div v-if="showFileExtension"
               class="download__extension">
            {{ extension }}
          </div>
          <div v-if="showFileSize"
               class="download__filesize">
            {{ size }}
          </div>
        </div>
      </div>
    </div>

    <a
      class="btn btn-accent-6"
      href="#"
      rel="noopener noreferrer"
      @click.prevent="downloadFile(url, name, extension)">
      Download
    </a>
  </div>
</template>

<script>
import downloadHelperMixin from "~/Scripts/mixins/downloaderMixin";

export default {
  mixins: [downloadHelperMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      required: true
    },
    extension: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: null
    },
    selectable: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: false
    },
    showFileExtension: {
      type: Boolean,
      default: false
    },
    showFileSize: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isChecked: this.value
    };
  },
  computed: {
    icon () {
      return this.getProductDownloadIcon( this.extension );
    }
  },
  watch: {
    value ( isChecked ) {
      this.isChecked = isChecked;
    }
  },
  methods: {
    handleUserSelectedDownload () {
      this.$emit( "input", this.isChecked );
    }
  }
};
</script>

<style scoped lang="less">
@import "../../Styles/utils/colors.less";

.download {
  display: flex;
  background: #ebf5ed;
  border-radius: 5px;
  padding: 15px;
  max-width: 500px;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  justify-content: space-between;

  &__content-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__icon {
    height: 50px;
    width: 50px;
    border: 1px solid #ccc;
    margin-right: 15px;
    border-radius: 5px;
    flex-shrink: 0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
  }

  &__header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__heading {
    font-size: 1rem;
    color: #000;
    margin-bottom: 5px;
  }

  &__info {
    display: flex;
    color: #000;
    font-size: 13px;
    text-transform: uppercase;
  }

  &__extension {
    padding-right: 5px;
  }

  &__select {
    display: flex;
    justify-content: flex-end;
    flex: 1;

    .form-group {
      margin-bottom: 0;
    }
  }

  .btn {
    border-radius: 100px;
    padding: 3px 30px;
    font-size: 13px;
    text-transform: uppercase;
  }

  @media (max-width: 991px) {
    max-width: 100%;
  }
}
</style>
